function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M30.344 10.97L29.03 9.655c-.876-.875-2.189-.875-3.064 0L10.074 25.55a.38.38 0 0 0-.104.194l-.96 4.8a.38.38 0 0 0 .447.447l4.8-.96a.38.38 0 0 0 .194-.104l15.893-15.893c.875-.875.875-2.188 0-3.064zM10.32 29.678l.657-3.392 2.735 2.735-3.392.657zm4.267-1.422l-2.844-2.845 12.254-12.254 2.844 2.844-12.254 12.255zm14.99-14.99l-1.86 1.86-2.845-2.845 1.86-1.86a1.058 1.058 0 0 1 1.532 0l1.313 1.313a1.058 1.058 0 0 1 0 1.532z"
});

var SvgPublications = function SvgPublications(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPublications, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Publications.96346fb7.svg";
export { ForwardRef as ReactComponent };